import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateBoardV3 = OpalApi<'CreateBoardV3', 201>

export const createBoard: CreateBoardV3 = async (args = {}) => {
  const url = new URL('/boards/v3', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
